import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Container, Row, Col, Card, CardImgOverlay, Input, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';
import { capitalizeFirstLetter } from '../../../../util/text';
import { getPriceCent, getPriceFromCent } from '../../../../util/price';

import { getSubscriptionPeriods, SUBSCRIPTION_MIN_QUANTITY } from '../../SubscriptionActions';
import { getProduct, getProductPrice, getProductMatchingPack } from '../../../Product/ProductActions';
import { setCartItem, getCartItemByProduct, getCartItemFromProduct, getCartSubscription, setCartSubscriptionPeriod } from '../../../Cart/CartActions';
import { getContentBlockItemByName, getContentBlockMixedItem, getContentBlockMixedItems } from '../../../Cms/CmsActions';
import { getLanguagePath } from '../../../Intl/IntlActions';

import FontCustom from '../../../../components/Content/FontCustom';
import Breadcrumbs from '../../../App/components/view/Breadcrumbs';
import FileLoader from '../../../../components/Content/FileLoader';
import HtmlComponent from '../../../../components/Text/HtmlComponent';
import Price from '../../../Currency/components/view/Price';
import CartItemQuantitySelector from '../../../Cart/components/form/CartItemQuantitySelector';
import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';
import CmsPanel from '../../../Cms/components/content/CmsPanel';
import ReviewSummary from '../../../Review/components/view/ReviewSummary';
import PreFooter from '../../../App/components/PreFooter';
import AppContact from '../../../App/components/AppContact';


class SubscriptionViewPage extends Component {
    handleSelectPack = pack => {
        this.props.dispatch(setCartItem(getCartItemFromProduct(this.props.product, pack.quantity, pack, this.props.intl.locale)));
    }

    handleSelectPeriod = period => {
        this.props.dispatch(setCartSubscriptionPeriod(period.unit, period.value));
    }

    handleAddToCart = () => {
        if(!this.props.cartItem || !this.props.cartItem.quantity) {
            this.handleSelectPack({ quantity: 1 });
        }
        this.props.history.push(getLanguagePath('/cart/preview', this.props.intl.locale));
    }

    render() {
        const { product, page, cartItem, cartSubscription, intl } = this.props;
        const matchingPack = getProductMatchingPack(product, cartItem ? cartItem.quantity : 1);

        const image = getContentBlockItemByName(page.blocks, 'image');
        const subtitle = (getContentBlockItemByName(page.blocks, 'subtitle') || {}).text || '';
        const title = (getContentBlockItemByName(page.blocks, 'title') || {}).text || '';
        const description = getContentBlockItemByName(page.blocks, 'description') || {};
        const shippingInfo = getContentBlockItemByName(page.blocks, 'shipping-info');

        const promotion = getContentBlockItemByName(page.blocks, 'promotion');
        const reductionRate = parseFloat(getContentBlockMixedItem(promotion, 'reduction') && getContentBlockMixedItem(promotion, 'reduction').text) || 0;

        const advantages = getContentBlockItemByName(page.blocks, 'advantages');

        const compositionSlide = getContentBlockItemByName(page.blocks, 'composition-slide');

        return (
            <Fragment>
                <Container>
                    <Card>
                        {image && <FileLoader filename={image.path} loadonmount className="card-img" style={{ minHeight: '200px' }} />}
                        <CardImgOverlay>
                            <Breadcrumbs crumb={page && page.title} />
                        </CardImgOverlay>
                    </Card>

                    <div className={classnames(image && 'override-block-lg')}>

                        <Row className="mb-3">
                            <Col xs={{ size: 12, order: 2 }} md={{ size: 7, order: 1 }}>
                                <div className="pr-0 pr-md-5">
                                    {subtitle && <span className="d-block mb-2 text-primary text-uppercase">{subtitle}</span>}
                                    {title && <h1 className="text-secondary font-weight-bold">{title}</h1>}
                                    <CmsBlockItem item={description} type="html" />

                                    {
                                        product
                                        ? (
                                            <Fragment>
                                                <h3 className="my-4 text-secondary"><FormattedMessage id="subscriptionConfigurationTitle" defaultMessage="Setup your subscription" /></h3>

                                                {
                                                    product.packs && product.packs.length
                                                        ? (
                                                            <Fragment>
                                                                <div className="mb-2 text-primary"><h5 className="d-inline-block"><FormattedMessage id="subscriptionConfigurationPackTitle" defaultMessage="Choose your pack" /></h5> <span><FormattedMessage id="priceHT" defaultMessage="Price excl. tax" /></span></div>
                                                                <Row className="mb-4">
                                                                    {product.packs.filter(pack => pack.quantity >= SUBSCRIPTION_MIN_QUANTITY).sort((packA, packB) => packA.quantity - packB.quantity).map((pack, index) => (
                                                                        <Col key={pack.label || index} xs="6" lg="4">
                                                                            <div
                                                                                onClick={() => this.handleSelectPack(pack)}
                                                                                className={classnames('position-relative', !pack.isMonthlyConsumption && 'my-2', 'p-2', pack.isMonthlyConsumption && 'pt-4', 'rounded', 'border', matchingPack && matchingPack.quantity === pack.quantity && ['border-warning', 'border-2'])}
                                                                            >
                                                                                {pack.isMonthlyConsumption && (
                                                                                    <span className={classnames('d-block', 'position-absolute', 'py-1', 'text-center', 'text-xs', 'w-100', matchingPack && matchingPack.quantity === pack.quantity ? ['bg-warning', 'text-white'] : 'bg-light')} style={{ top: '-5px', left: 0, borderRadius: '5px 5px 0 0', fontSize: '0.6rem' }}><FormattedMessage id="productPackMonthlyConsumptionLabel" defaultMessage="Recommended for 1 month" /></span>
                                                                                )}
                                                                                <div>
                                                                                    <FormattedMessage id="productUnitCountLabel" defaultMessage="{count} bottle(s)" values={{ count: pack.quantity }} />
                                                                                    {' '}{false && pack.freeCount > 0 && <FormattedMessage id="productPackFreeCount" defaultMessage="+{count} free" values={{ count: pack.freeCount }} />}
                                                                                </div>
                                                                                <div className="d-flex justify-content-between pt-1">
                                                                                    {product.priceHT !== pack.unitPriceHT ? <span className="d-block text-crossed"><Price amount={product.priceHT * pack.quantity} /></span> : <span>{' '}</span>}
                                                                                    <span className="d-block h5 m-0 text-dark font-weight-bold"><Price amount={getPriceFromCent((getPriceCent(pack.unitPriceHT) - ((reductionRate / 100) * getPriceCent(pack.unitPriceHT))) * pack.quantity)} /></span>
                                                                                </div>
                                                                                {!pack.freeCount && product.priceHT !== pack.unitPriceHT && <small className="text-secondary"><FormattedMessage id="productPackUnitPrice" defaultMessage="Or {price}/bottle" values={{ price: <Price amount={getPriceFromCent(getPriceCent(pack.unitPriceHT) - ((reductionRate / 100) * getPriceCent(pack.unitPriceHT)))} /> }} /></small>}
                                                                                {pack.freeCount > 0 && <small className="text-warning"><FormattedMessage id="productPackFreeCount" defaultMessage="+{count} free" values={{ count: pack.freeCount }} /></small>}
                                                                            </div>
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </Fragment>
                                                    ) : null
                                                }

                                                <h5 className="mb-2"><FormattedMessage id="subscriptionConfigurationPeriodTitle" defaultMessage="Choice of renewal date" /></h5>
                                                <Row className="mb-4">
                                                    {getSubscriptionPeriods().map((period, index) => (
                                                        <Col key={index} xs="6" md="4">
                                                            <div
                                                                onClick={() => this.handleSelectPeriod(period)}
                                                                className={classnames('position-relative', 'my-2', 'px-3', 'py-4', 'rounded', 'border', cartSubscription && cartSubscription.periodIntervalUnit === period.unit && cartSubscription.periodIntervalValue === period.value && ['border-warning', 'border-2'])}
                                                            >
                                                                <FormattedMessage id={`subscriptionPeriod${period.value}${capitalizeFirstLetter(period.unit)}`} defaultMessage={`${period.value} ${period.unit}(s)`} />
                                                            </div>
                                                        </Col>
                                                     ))}
                                                </Row>
                                            </Fragment>
                                        )
                                        : <strong className="text-danger">Product missing...</strong>
                                    }

                                    <div className="my-3">
                                        <CmsBlockItem item={shippingInfo} type="html" />
                                    </div>

                                    <div className="text-left">
                                        <Button color="warning" size="lg" disabled={!cartItem || !cartSubscription} onClick={this.handleAddToCart}><FormattedMessage id="subscriptionCreateButton" defaultMessage="I subscribe without obligation" /></Button>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={{ size: 12, order: 1 }} md={{ size: 5, order: 2 }} className="mb-3">
                                {
                                    promotion && (
                                        <Fragment>
                                            <div className="d-none d-md-block mt-5 px-3 bg-tertiary" style={{ paddingTop: '190px' }}>
                                                {getContentBlockMixedItem(promotion, 'image') && (
                                                    <div className="d-none d-md-block position-absolute w-100 text-center" style={{ top: '-200px', left: 0 }}>
                                                        <CmsBlockItem item={getContentBlockMixedItem(promotion, 'image')} type="image" className="w-75" />
                                                    </div>
                                                )}
                                                <Row>
                                                    <Col xs="12" md="6" className="pt-4 text-primary">
                                                        {getContentBlockMixedItem(promotion, 'title') && <span className="h5 text-primary font-weight-bold">{getContentBlockMixedItem(promotion, 'title').text}</span>}
                                                        {getContentBlockMixedItem(promotion, 'description') && <CmsBlockItem item={getContentBlockMixedItem(promotion, 'description')} type="html" />}
                                                    </Col>
                                                    {reductionRate && getContentBlockMixedItem(promotion, 'reduction') && getContentBlockMixedItem(promotion, 'reduction').text && (
                                                        <Col>
                                                            <div className="m-auto p-4 py-4 bg-light text-dark text-center" style={{ width: '150px', height: '150px', borderRadius: '150px', fontSize: '1.3rem' }}>
                                                                <span className="d-block pr-4 text-crossed"><Price amount={getProductPrice(product, SUBSCRIPTION_MIN_QUANTITY)} /></span>
                                                                <span className="d-block pt-1 font-weight-bold" style={{ fontSize: '2rem' }}><Price amount={getProductPrice(product, SUBSCRIPTION_MIN_QUANTITY) * (1 - (parseFloat(getContentBlockMixedItem(promotion, 'reduction').text) / 100))} /></span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                </Row>
                                                <div className="p-3">
                                                    {getContentBlockMixedItem(promotion, 'call-to-action') && getContentBlockMixedItem(promotion, 'call-to-action').text && (
                                                        <Button color="secondary" block tag={Link} to={getContentBlockMixedItem(promotion, 'call-to-action').path} className="mt-3">{getContentBlockMixedItem(promotion, 'call-to-action').text}</Button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-block d-md-none p-3 bg-tertiary">
                                                <div className="text-center"><CmsBlockItem item={getContentBlockMixedItem(promotion, 'image')} type="image" className="mb-3 w-75" /></div>
                                                {getContentBlockMixedItem(promotion, 'title') && <span className="h5 font-weight-bold">{getContentBlockMixedItem(promotion, 'title').text}</span>}
                                                {getContentBlockMixedItem(promotion, 'description') && <CmsBlockItem item={getContentBlockMixedItem(promotion, 'description')} type="html" />}
                                                {reductionRate && getContentBlockMixedItem(promotion, 'reduction') && getContentBlockMixedItem(promotion, 'reduction').text && (
                                                    <Col>
                                                        <div className="m-auto p-4 py-4 bg-light text-dark text-center" style={{ width: '150px', height: '150px', borderRadius: '150px', fontSize: '1.3rem' }}>
                                                            <span className="d-block pr-4 text-crossed"><Price amount={getProductPrice(product, SUBSCRIPTION_MIN_QUANTITY)} /></span>
                                                            <span className="d-block pt-1 font-weight-bold" style={{ fontSize: '2rem' }}><Price amount={getProductPrice(product, SUBSCRIPTION_MIN_QUANTITY) * (1 - (parseFloat(getContentBlockMixedItem(promotion, 'reduction').text) / 100))} /></span>
                                                        </div>
                                                    </Col>
                                                )}
                                                {getContentBlockMixedItem(promotion, 'call-to-action') && getContentBlockMixedItem(promotion, 'call-to-action').text && (
                                                    <Button color="secondary" block tag={Link} to={getContentBlockMixedItem(promotion, 'call-to-action').path} className="mt-3">{getContentBlockMixedItem(promotion, 'call-to-action').text}</Button>
                                                )}
                                            </div>
                                        </Fragment>
                                    )
                                }


                                {advantages && (
                                    <div className="my-3 text-primary">
                                        {getContentBlockMixedItem(advantages, 'title') && <span className="d-block h5 font-weight-bold">{getContentBlockMixedItem(advantages, 'title').text}</span>}

                                        {getContentBlockMixedItems(advantages, 'advantage').map((advantage, index) => (
                                            <div key={index} className="mb-2 d-flex" style={{ fontSize: '0.9em' }}>
                                                <FontCustom name="check" size="2" className="d-inline-block mr-1 pt-2" />
                                                <CmsBlockItem item={advantage} type="html" inline />
                                            </div>
                                        ))}
                                        {getContentBlockMixedItem(advantages, 'call-to-action') && getContentBlockMixedItem(advantages, 'call-to-action').text && (
                                            <Button color="light" size="lg" tag={Link} to={getContentBlockMixedItem(advantages, 'call-to-action').path} className="mt-3">{getContentBlockMixedItem(advantages, 'call-to-action').text}</Button>
                                        )}
                                    </div>
                                )}

                                <div className="d-none d-md-block mt-5">
                                    <AppContact hideEmail />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>

                {compositionSlide && (
                    <Container fluid className="bg-tertiary bg-custom-chemical">
                        <Container className="px-3 px-md-0 py-2 py-sm-5">
                            <Row>
                                <Col xs="12" sm="6" className="text-center">
                                    {getContentBlockMixedItem(compositionSlide, 'image') && <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'image')} type="image" className="image-shadow" />}
                                </Col>
                                <Col className="py-2 py-sm-5">
                                    <Row>
                                        <Col xs="12" lg="8" xl="6">
                                            <div className="pt-3 pt-md-0">
                                                {getContentBlockMixedItem(compositionSlide, 'subtitle') && (
                                                    <div className="mb-3 text-primary text-uppercase">
                                                        <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'subtitle')} type="text" />
                                                    </div>
                                                )}
                                                {getContentBlockMixedItem(compositionSlide, 'title') && (
                                                    <div className="h2 mb-3 special-font text-dark">
                                                        <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'title')} type="text" />
                                                    </div>
                                                )}

                                                {getContentBlockMixedItem(compositionSlide, 'text') && (
                                                    <div className="mb-3">
                                                        <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'text')} type="html" />
                                                    </div>
                                                )}
                                                <div className="text-center text-md-left">
                                                    {getContentBlockMixedItem(compositionSlide, 'call-to-action') && (
                                                        <Button color="light" size="lg" tag={Link} to={getContentBlockMixedItem(compositionSlide, 'call-to-action').path} className="mt-2">{getContentBlockMixedItem(compositionSlide, 'call-to-action').text}</Button>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                )}

                <PreFooter />
            </Fragment>
        );
    }
}

function mapStateToProps(store, props) {
    const productBlockItem = getContentBlockItemByName(props.page.blocks, 'product');
    const product = productBlockItem ? getProduct(store, productBlockItem.text) : null;
    return {
        product,
        cartItem: product ? getCartItemByProduct(store, product) : null,
        cartSubscription: getCartSubscription(store),
    };
}

SubscriptionViewPage.defaultProps = {
    product: null,
    cartItem: null,
    cartSubscription: null,
};

SubscriptionViewPage.propTypes = {
    page: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    product: PropTypes.object,
    cartItem: PropTypes.object,
    cartSubscription: PropTypes.object,
};

export default connect(mapStateToProps)(withRouter(injectIntl(SubscriptionViewPage)));


export const SubscriptionViewPageModel = {
    type: 'page',
    name: 'subscription',
    slug: 'subscribe',
    blocks: [
        {
            name: 'product', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'subtitle',
            max: 1,
            type: 'text',
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'description',
            max: 1,
            type: 'html',
        },
        {
            name: 'image',
            max: 1,
            type: 'image',
        },
        {
            name: 'shipping-info',
            max: 1,
            type: 'html',
        },
        {
            name: 'promotion',
            type: 'mixed',
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'description',
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'reduction',
                    type: 'text',
                    max: 1,
                },
            ],
        },
        {
            name: 'advantages',
            max: 1,
            type: 'mixed',
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'advantage',
                    type: 'text',
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
            ],
        },
        {
            name: 'composition-slide',
            type: 'mixed',
            max: 1,
            blocks: [
                {
                    name: 'subtitle',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text',
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'stamp-image',
                    type: 'image',
                    max: 1,
                },
            ],
        },
    ],
};
